import { QueuedItemStatus } from './QueuedItemStatus';

export interface ComboCombinationGq {
  readonly selected: boolean;
  readonly wordGroupIds: string[];
  readonly removeSpacing: number;
  readonly status: QueuedItemStatus;
}

export const ComboCombinationGqProps = `
  selected
  status
  wordGroupIds
  removeSpacing
`;
